import { Directive, OnInit } from '@angular/core';
import { MatFormField } from '@angular/material/form-field';

@Directive({
    selector: 'mat-form-field[paymentsFilterField]',
    standalone: false,
})
export class FilterFieldDirective implements OnInit {
    constructor(private matFormField: MatFormField) {}

    ngOnInit(): void {
        this.matFormField.floatLabel = 'auto';
        this.matFormField.subscriptSizing = 'dynamic';
    }
}
